import React, { useEffect, useState } from 'react';
import {
  Box, FormControl, InputLabel, Select, MenuItem, Typography,
} from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { getGmsSpaces } from '../../api/financeApi';
import { dropdownMenuProps } from '../../utils/dropdownStyles';

const FinanceSpaceSelector = ({ selectedSpaceId, onSpaceSelect }) => {
  const [spaces, setSpaces] = useState([]);

  useEffect(() => {
    getGmsSpaces().then(setSpaces).catch(() => {});
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    if (!val) { onSpaceSelect(null); return; }
    const space = spaces.find((s) => String(s.spaceId) === val);
    onSpaceSelect(space ?? null);
  };

  if (spaces.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 2,
          mb: 3,
          bgcolor: '#ecfdf5',
          border: '1px solid #a7f3d0',
          borderRadius: 2,
        }}
      >
        <AccountBalanceOutlinedIcon sx={{ color: '#059669', fontSize: 20, flexShrink: 0 }} />
        <Typography variant="body2" sx={{ color: '#065f46', fontWeight: 500 }}>
          You are not enrolled in any spaces. Ask an administrator to add you to a space.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 3, maxWidth: 360 }}>
      <FormControl fullWidth size="small">
        <InputLabel sx={{ '&.Mui-focused': { color: '#059669' } }}>
          Filter by Space
        </InputLabel>
        <Select
          value={selectedSpaceId != null ? String(selectedSpaceId) : ''}
          label="Filter by Space"
          onChange={handleChange}
          MenuProps={dropdownMenuProps}
          sx={{
            borderRadius: 2,
            bgcolor: 'white',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#a7f3d0' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#059669' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#059669' },
          }}
        >
          <MenuItem value="">
            <Typography variant="body2" sx={{ color: '#94a3b8', fontStyle: 'italic' }}>
              — Select a space —
            </Typography>
          </MenuItem>
          {spaces.map((space) => (
            <MenuItem key={space.spaceId} value={String(space.spaceId)}>
              {space.spaceName || `Space ${space.spaceId}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default FinanceSpaceSelector;
